module.exports = __webpack_public_path__ + "img/example-dashboard-call-center-en.4c317cff.png";